export default "__VITE_ASSET__Po0WIwoE__"